function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M345.375 3.41a10.001 10.001 0 00-17.055 7.09v53.36c-54.004 2.152-81.054 24.535-85.191 28.261a151.604 151.604 0 00-52.613 88.121 155.24 155.24 0 00-1.786 50.781l.008.059c.02.148.043.3.067.45l2.125 12.214a10.002 10.002 0 0018.426 3.434l6.367-10.614c19.562-32.53 43.941-54.093 72.468-64.09a105.104 105.104 0 0140.13-5.882v55.265a9.999 9.999 0 0017.09 7.051L451.085 122.7c3.894-3.915 3.879-10.247-.035-14.141zm0 0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M417.352 294.953c-5.52 0-10 4.477-10 10v42.266c-.016 16.558-13.438 29.98-30 30H50c-16.563-.02-29.98-13.442-30-30V108.973c.02-16.563 13.438-29.98 30-30h69.16c5.524 0 10-4.477 10-10 0-5.524-4.476-10-10-10H50c-27.602.03-49.969 22.398-50 50v238.246c.031 27.597 22.398 49.965 50 50h327.352c27.601-.035 49.968-22.403 50-50v-42.266c0-5.523-4.477-10-10-10zm0 0"
});

function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -28 453.998 453"
  }, props), _ref, _ref2);
}

export default SvgIconShare;